import { API_PATH } from 'common/constants/services';
import useQuery from 'hook/useQuery';
import React, { useEffect, useState } from 'react';

export type Root = Root2[];

export interface Root2 {
  id: number;
  name: string;
  description: string;
  purpose: string;
  total_date: number;
  author: string;
  youtube_id: any;
  thumbnail_image: any;
  writer: number;
  activated: boolean;
  is_private: boolean;
  protein_price: number;
}

export default function useCoachChallenge({
  userId,
  year,
  month,
}: {
  userId: number;
  year: number;
  month: number;
}) {
  const query = useQuery<Root>(API_PATH.COACH_CHALLENGE(userId), {
    year,
    month,
  });

  return { data: query.getQuery.data?.data };
}
